import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http:HttpClient) { }

    evaluatedRegister(data):Observable<any>{
      return this.http.post(`${environment.apiBaseUrl}/email/evaluatedRegister`, data);
    }

    clientRegister(data):Observable<any>{
      return this.http.post(`${environment.apiBaseUrl}/email/clientRegister`, data);
    }

    evaluatedTest(data):Observable<any>{
      return this.http.post(`${environment.apiBaseUrl}/email/evaluatedTest`, data);
    }

    changePassword(data):Observable<any>{
      return this.http.post(`${environment.apiBaseUrl}/email/passwordChange`, data);
    }

    sendMessage(data):Observable<any>{
      return this.http.post(`${environment.apiBaseUrl}/email/sendMessage`, data);
    }

    completeTest(data):Observable<any>{
      return this.http.post(`${environment.apiBaseUrl}/email/completeTest`, data);
    }


}
